/* eslint-disable */
import { supabase } from "../supabase";

// Legacy sync version — kept for backward compat, prefer generateUniqueSku
export function generateSKU(brand, existingItems) {
  if (!brand) return "";
  const prefix = brand.replace(/[^a-zA-Z]/g, "").toUpperCase().slice(0, 3).padEnd(3, "X");
  const year = new Date().getFullYear();
  const sameBrand = existingItems.filter(i => i.sku && i.sku.startsWith(`${prefix}-${year}-`));
  const nums = sameBrand.map(i => { const p = i.sku.split("-"); return parseInt(p[p.length-1]) || 0; });
  const next = (nums.length ? Math.max(...nums) : 0) + 1;
  return `${prefix}-${year}-${String(next).padStart(3, "0")}`;
}

// ── Async DB-backed SKU generator — guarantees uniqueness ──────────────────
export async function generateUniqueSku(brand) {
  if (!brand) return "";
  const prefix = brand.replace(/[^a-zA-Z]/g, "").toUpperCase().slice(0, 3).padEnd(3, "X");
  const year = new Date().getFullYear();
  const pattern = `${prefix}-${year}-%`;
  const { data } = await supabase
    .from('items')
    .select("data->>sku")
    .like("data->>sku", pattern);
  const existingSkus = (data || []).map(r => r.sku).filter(Boolean);
  let maxNum = 0;
  existingSkus.forEach(sku => {
    const parts = sku.split("-");
    const num = parseInt(parts[parts.length - 1]);
    if (!isNaN(num) && num > maxNum) maxNum = num;
  });
  const candidate = `${prefix}-${year}-${String(maxNum + 1).padStart(3, "0")}`;
  return candidate;
}

// ── Pre-save SKU conflict resolver — auto-recovery, no user intervention ───
export async function ensureUniqueSku(sku, brand, currentItemId) {
  if (!sku) return sku;
  const { data: conflicts } = await supabase
    .from('items')
    .select('id')
    .eq("data->>sku", sku.trim())
    .limit(5);
  const realConflict = (conflicts || []).some(r => String(r.id) !== String(currentItemId || ""));
  if (!realConflict) return sku;
  return await generateUniqueSku(brand);
}
